import axios from 'axios';
import { InboxItem, AttentionSnapshot, DemoScenario, DemoSeedResult } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
const DEMO_TOKEN = process.env.REACT_APP_DEMO_TOKEN || 'demo_secret_2024';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const api = {
  // Get priority inbox items
  getInbox: async (limit: number = 100): Promise<InboxItem[]> => {
    const response = await axiosInstance.get(`/api/inbox?limit=${limit}`);
    return response.data;
  },

  // Get attention analytics
  getAnalytics: async (): Promise<AttentionSnapshot> => {
    const response = await axiosInstance.get('/api/analytics');
    return response.data;
  },

  // Accept a task
  acceptTask: async (taskId: string) => {
    const response = await axiosInstance.post(`/api/tasks/${taskId}/accept`);
    return response.data;
  },

  // Request clarification on a task
  clarifyTask: async (taskId: string) => {
    const response = await axiosInstance.post(`/api/tasks/${taskId}/clarify`);
    return response.data;
  },

  // Export report
  exportReport: async (format: 'json' | 'csv') => {
    const response = await axiosInstance.get(`/api/export/report?format=${format}`, {
      responseType: format === 'csv' ? 'text' : 'json'
    });
    return response.data;
  },

  // Health check
  getHealth: async () => {
    const response = await axiosInstance.get('/api/health');
    return response.data;
  },

  // Refresh data
  refreshData: async () => {
    const response = await axiosInstance.post('/api/refresh');
    return response.data;
  },

  // Demo scenario management
  getDemoScenarios: async (): Promise<DemoScenario[]> => {
    const response = await axiosInstance.get('/api/demo/scenarios');
    return response.data.scenarios;
  },

  seedDemoScenario: async (scenarioKey: string, clearExisting: boolean = false): Promise<DemoSeedResult> => {
    const response = await axiosInstance.post(
      `/api/demo/seed?scenario_key=${scenarioKey}&clear_existing=${clearExisting}`,
      {},
      {
        headers: {
          'X-Demo-Token': DEMO_TOKEN
        }
      }
    );
    return response.data;
  },

  clearDemoData: async () => {
    const response = await axiosInstance.post(
      '/api/demo/clear',
      {},
      {
        headers: {
          'X-Demo-Token': DEMO_TOKEN
        }
      }
    );
    return response.data;
  }
};